import Outlined from '../div/Outlined'
import Testimony from '../testimony/Testimony'
import monialData from './data'
import './testimonial.css'

function Testimonial() {
    return (
        <div className='testimonial'>
            <h3>What they say about Us</h3>
            <Outlined/>
            <div className='testimonialWrapper'>
               {monialData.map((data) => (
                <Testimony data={data}/>   
               ))}
            </div>
        </div>
    )
}

export default Testimonial
